//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as _ from "lodash";
export class BaseClient {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        this.jsonParseReviver = jsonParseReviver;
    }
}

export class AccessTokensClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<AccessTokenListModel> {
        let url_ = this.baseUrl + "/api/access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<AccessTokenListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessTokenListModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessTokenListModel>(null as any);
    }

    update(id: string, body?: AccessTokenInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param expireFrom (optional) 
     * @param expireTo (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, expireFrom?: Date | undefined, expireTo?: Date | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<AccessTokenListModel[]> {
        let url_ = this.baseUrl + "/api/access-tokens?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (expireFrom === null)
            throw new globalThis.Error("The parameter 'expireFrom' cannot be null.");
        else if (expireFrom !== undefined)
            url_ += "ExpireFrom=" + encodeURIComponent(expireFrom ? "" + expireFrom.toISOString() : "") + "&";
        if (expireTo === null)
            throw new globalThis.Error("The parameter 'expireTo' cannot be null.");
        else if (expireTo !== undefined)
            url_ += "ExpireTo=" + encodeURIComponent(expireTo ? "" + expireTo.toISOString() : "") + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<AccessTokenListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessTokenListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessTokenListModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: AccessTokenInputModel | undefined): Promise<AccessTokenOnceOffDisplayModel> {
        let url_ = this.baseUrl + "/api/access-tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<AccessTokenOnceOffDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessTokenOnceOffDisplayModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessTokenOnceOffDisplayModel>(null as any);
    }
}

export class AuthorizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getUserAccess(domainName: string, emailAddress: string): Promise<UserAccessDisplayModel> {
        let url_ = this.baseUrl + "/api/users/access/{domainName}/{emailAddress}";
        if (domainName === undefined || domainName === null)
            throw new globalThis.Error("The parameter 'domainName' must be defined.");
        url_ = url_.replace("{domainName}", encodeURIComponent("" + domainName));
        if (emailAddress === undefined || emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAccess(_response);
        });
    }

    protected processGetUserAccess(response: Response): Promise<UserAccessDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAccessDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccessDisplayModel>(null as any);
    }

    /**
     * @return OK
     */
    getUserAccessByPersonalAccessToken(personalAccessToken: string): Promise<UserAccessDisplayModel> {
        let url_ = this.baseUrl + "/api/users/access-by-pat/{personalAccessToken}";
        if (personalAccessToken === undefined || personalAccessToken === null)
            throw new globalThis.Error("The parameter 'personalAccessToken' must be defined.");
        url_ = url_.replace("{personalAccessToken}", encodeURIComponent("" + personalAccessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAccessByPersonalAccessToken(_response);
        });
    }

    protected processGetUserAccessByPersonalAccessToken(response: Response): Promise<UserAccessDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAccessDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccessDisplayModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body?: UserAuthenticationInputModel | undefined): Promise<UserAuthenticationOutputModel> {
        let url_ = this.baseUrl + "/api/users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<UserAuthenticationOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAuthenticationOutputModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAuthenticationOutputModel>(null as any);
    }
}

export class BranchesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getByName(domain: string, name: string): Promise<BranchDisplayModel> {
        let url_ = this.baseUrl + "/api/branches/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<BranchDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BranchDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchDisplayModel>(null as any);
    }

    update(domain: string, name: string, body?: BranchInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/branches/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(domain: string, name: string): Promise<void> {
        let url_ = this.baseUrl + "/api/branches/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param showBanner (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, showBanner?: boolean | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<BranchListModel[]> {
        let url_ = this.baseUrl + "/api/branches?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (showBanner === null)
            throw new globalThis.Error("The parameter 'showBanner' cannot be null.");
        else if (showBanner !== undefined)
            url_ += "ShowBanner=" + encodeURIComponent("" + showBanner) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<BranchListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BranchListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BranchListModel[]>(null as any);
    }

    upsert(body?: BranchInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/branches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteById(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/branches/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompaniesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<CompanyDisplayModel> {
        let url_ = this.baseUrl + "/api/companies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<CompanyDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDisplayModel>(null as any);
    }

    update(id: string, body?: CompanyInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/companies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/companies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getByName(domain: string, name: string): Promise<CompanyDisplayModel> {
        let url_ = this.baseUrl + "/api/companies/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<CompanyDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDisplayModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<CompanyListModel[]> {
        let url_ = this.baseUrl + "/api/companies?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<CompanyListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyListModel[]>(null as any);
    }

    create(body?: CompanyInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLookups(): Promise<CompanyLookup[]> {
        let url_ = this.baseUrl + "/api/companies/lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookups(_response);
        });
    }

    protected processGetLookups(response: Response): Promise<CompanyLookup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyLookup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyLookup[]>(null as any);
    }
}

export class GroupsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<GroupDisplayModel> {
        let url_ = this.baseUrl + "/api/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<GroupDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupDisplayModel>(null as any);
    }

    update(id: string, body?: GroupInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getByName(domain: string, name: string): Promise<GroupDisplayModel> {
        let url_ = this.baseUrl + "/api/groups/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<GroupDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupDisplayModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<GroupListModel[]> {
        let url_ = this.baseUrl + "/api/groups?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<GroupListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupListModel[]>(null as any);
    }

    create(body?: GroupInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param domainName (optional) 
     * @return OK
     */
    getLookups(domainName?: string | undefined): Promise<GroupLookup[]> {
        let url_ = this.baseUrl + "/api/groups/lookups?";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "domainName=" + encodeURIComponent("" + domainName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookups(_response);
        });
    }

    protected processGetLookups(response: Response): Promise<GroupLookup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupLookup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupLookup[]>(null as any);
    }
}

export class IdentityProvidersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLookups(): Promise<IdentityProviderLookup[]> {
        let url_ = this.baseUrl + "/api/identity-providers/lookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookups(_response);
        });
    }

    protected processGetLookups(response: Response): Promise<IdentityProviderLookup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdentityProviderLookup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityProviderLookup[]>(null as any);
    }
}

export class LicencesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registerApplication(body?: ApplicationRegistrationRequest | undefined): Promise<ApplicationLicenseModel> {
        let url_ = this.baseUrl + "/api/licenses/register-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterApplication(_response);
        });
    }

    protected processRegisterApplication(response: Response): Promise<ApplicationLicenseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationLicenseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationLicenseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deregisterApplication(body?: ApplicationRegistrationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/licenses/deregister-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeregisterApplication(_response);
        });
    }

    protected processDeregisterApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PersonalAccessTokensClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<PersonalAccessTokenListModel> {
        let url_ = this.baseUrl + "/api/personal-access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<PersonalAccessTokenListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonalAccessTokenListModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalAccessTokenListModel>(null as any);
    }

    update(id: string, body?: PersonalAccessTokenInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/personal-access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/personal-access-tokens/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param name (optional) 
     * @param expireFrom (optional) 
     * @param expireTo (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(userId?: string | undefined, name?: string | undefined, expireFrom?: Date | undefined, expireTo?: Date | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<PersonalAccessTokenListModel[]> {
        let url_ = this.baseUrl + "/api/personal-access-tokens?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (expireFrom === null)
            throw new globalThis.Error("The parameter 'expireFrom' cannot be null.");
        else if (expireFrom !== undefined)
            url_ += "ExpireFrom=" + encodeURIComponent(expireFrom ? "" + expireFrom.toISOString() : "") + "&";
        if (expireTo === null)
            throw new globalThis.Error("The parameter 'expireTo' cannot be null.");
        else if (expireTo !== undefined)
            url_ += "ExpireTo=" + encodeURIComponent(expireTo ? "" + expireTo.toISOString() : "") + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PersonalAccessTokenListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonalAccessTokenListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalAccessTokenListModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: PersonalAccessTokenInputModel | undefined): Promise<PersonalAccessTokenOnceOffDisplayModel> {
        let url_ = this.baseUrl + "/api/personal-access-tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<PersonalAccessTokenOnceOffDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonalAccessTokenOnceOffDisplayModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalAccessTokenOnceOffDisplayModel>(null as any);
    }
}

export class PluginsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<PluginDisplayModel> {
        let url_ = this.baseUrl + "/api/plugins/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<PluginDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PluginDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PluginDisplayModel>(null as any);
    }

    deleteById(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/plugins/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getByName(domain: string, name: string): Promise<PluginDisplayModel> {
        let url_ = this.baseUrl + "/api/plugins/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<PluginDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PluginDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PluginDisplayModel>(null as any);
    }

    update(domain: string, name: string, body?: PluginInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/plugins/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(domain: string, name: string): Promise<void> {
        let url_ = this.baseUrl + "/api/plugins/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param isEnabled (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, isEnabled?: boolean | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<PluginListModel[]> {
        let url_ = this.baseUrl + "/api/plugins?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isEnabled === null)
            throw new globalThis.Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "IsEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PluginListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PluginListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PluginListModel[]>(null as any);
    }

    upsert(body?: PluginInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/plugins";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RolesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<RoleDisplayModel> {
        let url_ = this.baseUrl + "/api/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<RoleDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDisplayModel>(null as any);
    }

    update(id: string, body?: RoleInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getByName(domain: string, name: string): Promise<RoleDisplayModel> {
        let url_ = this.baseUrl + "/api/roles/{domain}/{name}";
        if (domain === undefined || domain === null)
            throw new globalThis.Error("The parameter 'domain' must be defined.");
        url_ = url_.replace("{domain}", encodeURIComponent("" + domain));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByName(_response);
        });
    }

    protected processGetByName(response: Response): Promise<RoleDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDisplayModel>(null as any);
    }

    /**
     * @param name (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(name?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<RoleListModel[]> {
        let url_ = this.baseUrl + "/api/roles?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<RoleListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleListModel[]>(null as any);
    }

    create(body?: RoleInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param domainName (optional) 
     * @return OK
     */
    getLookups(domainName?: string | undefined): Promise<RoleLookup[]> {
        let url_ = this.baseUrl + "/api/roles/lookups?";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "domainName=" + encodeURIComponent("" + domainName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLookups(_response);
        });
    }

    protected processGetLookups(response: Response): Promise<RoleLookup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleLookup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleLookup[]>(null as any);
    }
}

export class SettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param domainName (optional) 
     * @param branchName (optional) 
     * @return OK
     */
    getClientSettings(domainName?: string | undefined, branchName?: string | undefined): Promise<ClientAppSettings> {
        let url_ = this.baseUrl + "/api/settings/client?";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "domainName=" + encodeURIComponent("" + domainName) + "&";
        if (branchName === null)
            throw new globalThis.Error("The parameter 'branchName' cannot be null.");
        else if (branchName !== undefined)
            url_ += "branchName=" + encodeURIComponent("" + branchName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientSettings(_response);
        });
    }

    protected processGetClientSettings(response: Response): Promise<ClientAppSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientAppSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientAppSettings>(null as any);
    }

    /**
     * @param domainName (optional) 
     * @return OK
     */
    getTenantTheme(domainName?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/settings/tenant-theme?";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "domainName=" + encodeURIComponent("" + domainName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantTheme(_response);
        });
    }

    protected processGetTenantTheme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TenantsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<TenantDisplayModel> {
        let url_ = this.baseUrl + "/api/tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<TenantDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDisplayModel>(null as any);
    }

    update(id: string, body?: TenantInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param licenseExpiryDateFrom (optional) 
     * @param licenseExpiryDateTo (optional) 
     * @param ownerName (optional) 
     * @param company (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(licenseExpiryDateFrom?: Date | undefined, licenseExpiryDateTo?: Date | undefined, ownerName?: string | undefined, company?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<TenantListModel[]> {
        let url_ = this.baseUrl + "/api/tenants?";
        if (licenseExpiryDateFrom === null)
            throw new globalThis.Error("The parameter 'licenseExpiryDateFrom' cannot be null.");
        else if (licenseExpiryDateFrom !== undefined)
            url_ += "LicenseExpiryDateFrom=" + encodeURIComponent(licenseExpiryDateFrom ? "" + licenseExpiryDateFrom.toISOString() : "") + "&";
        if (licenseExpiryDateTo === null)
            throw new globalThis.Error("The parameter 'licenseExpiryDateTo' cannot be null.");
        else if (licenseExpiryDateTo !== undefined)
            url_ += "LicenseExpiryDateTo=" + encodeURIComponent(licenseExpiryDateTo ? "" + licenseExpiryDateTo.toISOString() : "") + "&";
        if (ownerName === null)
            throw new globalThis.Error("The parameter 'ownerName' cannot be null.");
        else if (ownerName !== undefined)
            url_ += "OwnerName=" + encodeURIComponent("" + ownerName) + "&";
        if (company === null)
            throw new globalThis.Error("The parameter 'company' cannot be null.");
        else if (company !== undefined)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<TenantListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantListModel[]>(null as any);
    }

    create(body?: TenantInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param licenseExpiryDateFrom (optional) 
     * @param licenseExpiryDateTo (optional) 
     * @param ownerName (optional) 
     * @param company (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    searchVerbose(licenseExpiryDateFrom?: Date | undefined, licenseExpiryDateTo?: Date | undefined, ownerName?: string | undefined, company?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<TenantDisplayModel[]> {
        let url_ = this.baseUrl + "/api/tenants/verbose?";
        if (licenseExpiryDateFrom === null)
            throw new globalThis.Error("The parameter 'licenseExpiryDateFrom' cannot be null.");
        else if (licenseExpiryDateFrom !== undefined)
            url_ += "LicenseExpiryDateFrom=" + encodeURIComponent(licenseExpiryDateFrom ? "" + licenseExpiryDateFrom.toISOString() : "") + "&";
        if (licenseExpiryDateTo === null)
            throw new globalThis.Error("The parameter 'licenseExpiryDateTo' cannot be null.");
        else if (licenseExpiryDateTo !== undefined)
            url_ += "LicenseExpiryDateTo=" + encodeURIComponent(licenseExpiryDateTo ? "" + licenseExpiryDateTo.toISOString() : "") + "&";
        if (ownerName === null)
            throw new globalThis.Error("The parameter 'ownerName' cannot be null.");
        else if (ownerName !== undefined)
            url_ += "OwnerName=" + encodeURIComponent("" + ownerName) + "&";
        if (company === null)
            throw new globalThis.Error("The parameter 'company' cannot be null.");
        else if (company !== undefined)
            url_ += "Company=" + encodeURIComponent("" + company) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchVerbose(_response);
        });
    }

    protected processSearchVerbose(response: Response): Promise<TenantDisplayModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TenantDisplayModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDisplayModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getIdentityProviders(domainName: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/tenants/{domainName}/identity-providers";
        if (domainName === undefined || domainName === null)
            throw new globalThis.Error("The parameter 'domainName' must be defined.");
        url_ = url_.replace("{domainName}", encodeURIComponent("" + domainName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentityProviders(_response);
        });
    }

    protected processGetIdentityProviders(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class UsersClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Promise<UserDisplayModel> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<UserDisplayModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDisplayModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDisplayModel>(null as any);
    }

    update(id: string, body?: UserInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param role (optional) 
     * @param group (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    search(emailAddress?: string | undefined, role?: string | undefined, group?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<UserListModel[]> {
        let url_ = this.baseUrl + "/api/users?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (group === null)
            throw new globalThis.Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<UserListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserListModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserListModel[]>(null as any);
    }

    create(sendWelcomeEmail?: boolean | undefined, body?: UserInputModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users?";
        if (sendWelcomeEmail === null)
            throw new globalThis.Error("The parameter 'sendWelcomeEmail' cannot be null.");
        else if (sendWelcomeEmail !== undefined)
            url_ += "sendWelcomeEmail=" + encodeURIComponent("" + sendWelcomeEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param role (optional) 
     * @param group (optional) 
     * @param domainName (optional) 
     * @param orderBy (optional) 
     * @return OK
     */
    searchVerbose(emailAddress?: string | undefined, role?: string | undefined, group?: string | undefined, domainName?: string | undefined, orderBy?: string | undefined): Promise<UserDisplayModel[]> {
        let url_ = this.baseUrl + "/api/users/verbose?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (role === null)
            throw new globalThis.Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (group === null)
            throw new globalThis.Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (domainName === null)
            throw new globalThis.Error("The parameter 'domainName' cannot be null.");
        else if (domainName !== undefined)
            url_ += "DomainName=" + encodeURIComponent("" + domainName) + "&";
        if (orderBy === null)
            throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchVerbose(_response);
        });
    }

    protected processSearchVerbose(response: Response): Promise<UserDisplayModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDisplayModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDisplayModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllowedTagsForUser(domainName: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/users/{domainName}/tags";
        if (domainName === undefined || domainName === null)
            throw new globalThis.Error("The parameter 'domainName' must be defined.");
        url_ = url_.replace("{domainName}", encodeURIComponent("" + domainName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllowedTagsForUser(_response);
        });
    }

    protected processGetAllowedTagsForUser(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }
}

export interface AccessTokenInputModel {
    name: string;
    domainName?: string | undefined;
    expiryDate: Date;
}

export interface AccessTokenListModel {
    id: string;
    name: string;
    domainName: string;
    expiryDate: Date;
}

export interface AccessTokenOnceOffDisplayModel {
    id: string;
    name: string;
    domainName: string;
    token: string;
    expiryDate: Date;
}

export interface ApplicationLicenseModel {
    domainName: string;
    licenseInformation: string;
    signature: string;
}

export interface ApplicationRegistrationRequest {
    accessToken: string;
    applicationId: string;
    instanceId: string;
}

export interface BranchBannerSettings {
    severity: string;
    content: string;
}

export interface BranchDisplayModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    dynamicDataApiUrl: string;
    defaultPageUrl?: string | undefined;
    isInMaintenanceMode: boolean;
    maintenanceMessageTitle?: string | undefined;
    maintenanceMessageBody?: string | undefined;
    showBanner: boolean;
    bannerSeverity: string;
    bannerContent: string;
}

export interface BranchInputModel {
    name: string;
    domainName?: string | undefined;
    dynamicDataApiUrl: string;
    defaultPageUrl?: string | undefined;
    isInMaintenanceMode: boolean;
    maintenanceMessageTitle?: string | undefined;
    maintenanceMessageBody?: string | undefined;
    showBanner: boolean;
    bannerSeverity: string;
    bannerContent: string;
}

export interface BranchListModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    dynamicDataApiUrl: string;
    defaultPageUrl?: string | undefined;
    isInMaintenanceMode: boolean;
    showBanner: boolean;
}

export interface ClientAppSettings {
    auth: ClientAuthSettings;
    allowAnonymousAuthentication: boolean;
    logoUrl: string;
    tenantId: string;
    tenantName: string;
    domainName: string;
    googleApiKey: string;
    storylineDownloadApiUrl: string;
    metastoreUrl: string;
    activeBranch: string;
    currentBranch: string;
    maxDatasourceRetryCount: number;
    errorNotificationLevel: string;
    dynamicDataApiUrl: string;
    defaultPageUrl: string;
    owner?: OwnerSettings | undefined;
    features: TenantFeatureFlags;
    maintenanceMode?: MaintenanceModeSettings | undefined;
    branchBanner?: BranchBannerSettings | undefined;
    plugins: PluginSettings[];
    appInsightsInstrumentationKey?: string | undefined;
    openReplay?: OpenReplaySettings | undefined;
}

export interface ClientAuthSettings {
    tenantId: string;
    instance: string;
    domain: string;
    clientId: string;
    readonly audience: string;
    signUpSignInPolicyId: string;
    signInUsingPatPolicyId: string;
    authApiBaseUrl: string;
    readonly authEndpoint: string;
    readonly tokenEndpoint: string;
    readonly patAuthEndpoint: string;
    readonly logoutEndpoint: string;
    readonly jwtKeysEndpoint: string;
    readonly jwtIssuer: string;
    environment: string;
}

export interface CompanyDisplayModel {
    id: string;
    name: string;
    description: string;
}

export interface CompanyInputModel {
    name: string;
    domainName?: string | undefined;
    description: string;
}

export interface CompanyListModel {
    id: string;
    name: string;
    description: string;
}

export interface CompanyLookup {
    id: string;
    name: string;
    description: string;
    isAssignable: boolean;
}

export interface GroupDisplayModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    description: string;
    roles: string[];
    userMetadata: MetadataEntry[];
}

export interface GroupInputModel {
    name: string;
    domainName?: string | undefined;
    description: string;
    roles: string[];
    userMetadata: MetadataEntry[];
}

export interface GroupListModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    description: string;
    roles: string[];
}

export interface GroupLookup {
    id: string;
    name: string;
    description: string;
}

export interface IdentityProviderLookup {
    id: string;
    name: string;
    description: string;
}

export interface LicenseDisplayModel {
    expiryDate: Date;
    enforcementDate: Date;
    maxConcurrentInstances: number;
    maxDaysOffline: number;
}

export interface LicenseInputModel {
    expiryDate: Date;
    maxConcurrentInstances: number;
    maxDaysOffline: number;
}

export interface MaintenanceModeSettings {
    title?: string | undefined;
    body?: string | undefined;
}

export interface MetadataEntry {
    field: string;
    value: string;
}

export interface OpenReplayConfig {
    isEnabled: boolean;
    projectKey: string;
    ingestPoint?: string | undefined;
    extraOptionsJson?: string | undefined;
}

export interface OpenReplaySettings {
    isEnabled: boolean;
    projectKey: string;
    ingestPoint?: string | undefined;
    extraOptionsJson?: string | undefined;
}

export interface Owner {
    name: string;
    emailAddress: string;
}

export interface OwnerSettings {
    name: string;
    emailAddress: string;
}

export interface PersonalAccessTokenInputModel {
    name: string;
    domainName?: string | undefined;
    userId: string;
    expiryDate: Date;
}

export interface PersonalAccessTokenListModel {
    id: string;
    userId: string;
    name: string;
    domainName: string;
    expiryDate: Date;
}

export interface PersonalAccessTokenOnceOffDisplayModel {
    id: string;
    userId: string;
    name: string;
    domainName: string;
    token: string;
    expiryDate: Date;
}

export interface PluginBranchMappingDisplayModel {
    pattern: string;
    url: string;
}

export interface PluginBranchMappingInputModel {
    pattern: string;
    url: string;
}

export interface PluginDisplayModel {
    id: string;
    name: string;
    domainName: string;
    description: string;
    branchMappings: PluginBranchMappingDisplayModel[];
    isEnabled: boolean;
}

export interface PluginInputModel {
    name: string;
    domainName?: string | undefined;
    description: string;
    branchMappings: PluginBranchMappingInputModel[];
    isEnabled: boolean;
}

export interface PluginListModel {
    id: string;
    name: string;
    domainName: string;
    description: string;
    branchMappingsCount: number;
    isEnabled: boolean;
}

export interface PluginSettings {
    name: string;
    url: string;
}

export interface RoleDisplayModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    description: string;
    inheritsFrom: string[];
    explicitTags: TagList;
    inheritedTags: TagList;
    readonly allTags: TagList;
}

export interface RoleInputModel {
    name: string;
    domainName?: string | undefined;
    description: string;
    inheritsFrom: string[];
    explicitTags: TagList;
}

export interface RoleListModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    description: string;
    inheritsFrom: string[];
    explicitTags: TagList;
    inheritedTags: TagList;
    readonly allTags: TagList;
}

export interface RoleLookup {
    id: string;
    name: string;
    description: string;
    isAssignable: boolean;
}

export interface Tag {
    key: string;
    value: string;
}

export interface TagList {
    allowed: Tag[];
    denied: Tag[];
}

export interface TenantDisplayModel {
    id?: string | undefined;
    domainName: string;
    name: string;
    allowAnonymousAuthentication: boolean;
    logoUrl?: string | undefined;
    customThemeUrl?: string | undefined;
    metastoreUrl?: string | undefined;
    activeBranch?: string | undefined;
    errorNotificationLevel?: string | undefined;
    maxDatasourceRetryCount: number;
    license?: LicenseDisplayModel | undefined;
    owner?: Owner | undefined;
    identityProviders: string[];
    features: TenantFeatureFlags;
    company?: string | undefined;
    appInsightsInstrumentationKey?: string | undefined;
    openReplay?: OpenReplayConfig | undefined;
}

export interface TenantFeatureFlags {
    requestSupport: boolean;
}

export interface TenantInputModel {
    name: string;
    domainName?: string | undefined;
    allowAnonymousAuthentication: boolean;
    logoUrl?: string | undefined;
    customThemeUrl?: string | undefined;
    metastoreUrl?: string | undefined;
    activeBranch?: string | undefined;
    errorNotificationLevel?: string | undefined;
    maxDatasourceRetryCount: number;
    license?: LicenseInputModel | undefined;
    owner?: Owner | undefined;
    identityProviders: string[];
    features: TenantFeatureFlags;
    company?: string | undefined;
    appInsightsInstrumentationKey?: string | undefined;
    openReplay?: OpenReplayConfig | undefined;
}

export interface TenantListModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    ownerName?: string | undefined;
    licenseExpiryDate?: Date | undefined;
    company?: string | undefined;
}

export interface UserAccessDisplayModel {
    userId: string;
    name: string;
    domain: string;
    tenantName: string;
    emailAddress: string;
    roles: string[];
    allowedTags: string[];
    deniedTags: string[];
    userMetadata: string[];
}

export interface UserAuthenticationInputModel {
    personalAccessToken: string;
}

export interface UserAuthenticationOutputModel {
    access_token: string;
    token_type: string;
    expires_in: string;
    id_token: string;
}

export interface UserDisplayModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    schemaVersion: string;
    emailAddress: string;
    roles: string[];
    groups: string[];
    explicitTags: TagList;
    userMetadata: MetadataEntry[];
}

export interface UserInputModel {
    name: string;
    domainName?: string | undefined;
    emailAddress: string;
    roles: string[];
    groups: string[];
    explicitTags: TagList;
    userMetadata: MetadataEntry[];
}

export interface UserListModel {
    id: string;
    name: string;
    domainName?: string | undefined;
    emailAddress: string;
    roles: string[];
    groups: string[];
}

export interface ValidationErrorResponse {
    errors: { [key: string]: string[]; };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

export function jsonParseReviver(key, value) {
    var dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
    if (typeof value === 'string' && dateRegex.exec(value)) {
        // We don't want to treat naive datetime objects as UTC just yet, since most clients are returning local times naively...
        //if (!_.includes(value, '+') && !_.endsWith(value, 'Z')) {
        //    value = value + 'Z';
        //}

        const parsedDate = new Date(value);
        // Fall back to raw string value if parsed date is invalid...
        return (parsedDate instanceof Date && !isNaN(parsedDate.valueOf())) ?
            parsedDate :
            value;
    }
    return value;
}